"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PROJECT = exports.UPDATE_PROJECT = void 0;
const react_1 = __importDefault(require("react"));
const schema_1 = __importDefault(require("./schema"));
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
const route_1 = require("../route");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
const Usage_1 = require("../../../../components/Usage");
exports.UPDATE_PROJECT = route_1.PROJECT.sub("/edit", Project);
exports.ADD_PROJECT = route_1.PROJECTS.sub("/edit/new", Project);
function Project({ projectId }) {
    const { projectRole: role } = (0, auth_1.useProjectPageAuthorization)(projectId);
    const isMaster = role === "master";
    const { data, loading, set, remove, isEditing, ref } = (0, models_hook_1.useProjectDoc)({
        projectId,
    });
    const { list: usageList, loading: usageLoading } = (0, models_hook_1.useMonthlyUsageList)({
        projectId,
        userId: "$project",
    });
    const parameter = {
        title: isEditing ? "プロジェクト詳細" : "プロジェクト新規作成",
        schema: (0, schema_1.default)({ projectId }),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: set,
            path: () => (0, index_1.resolveRoute)("LIST_PROJECTS"),
            isDisabled: !isMaster,
        },
        clipboard: {
            objectType: "project",
            retainKeys: ["projectId"],
        },
        // remove: isEditing ? { handler: remove } : undefined,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: data, parameter: parameter, loading: isEditing && loading, header: react_1.default.createElement(standard_1.AdminLocaleSelector, { locales: data === null || data === void 0 ? void 0 : data.availableLocales }), editModeEnabled: true }),
        react_1.default.createElement("div", { style: { margin: "2rem" } },
            react_1.default.createElement(Usage_1.Usage, { usageList: usageList || [] }))));
}
exports.default = Project;
